import React from 'react';
import {
  styled,
  Brand,
  Logos,
  Container,
  Typography,
} from '@nextiva/next-ui-components';

const PermissionContainer = styled(Container)`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const Header = styled(Typography)`
  margin-top: 23px;
`;

const Subtitle = styled(Typography)`
  margin-top: 16px;
`;

const PermissionNeeded = () => {
  return (
    <PermissionContainer>
      <Brand logo={Logos.brandIcon} sx={{ height: '48px' }} />
      <Header variant="h3">Permission needed.</Header>
      <Subtitle variant="subtitle1">
        You have reached a page that requires additional access.
      </Subtitle>
    </PermissionContainer>
  );
};

export default PermissionNeeded;
